<template>
       <div class="container">
                <div class="page-header">
                    <div class="page-title">

                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li class="active">
                                  <router-link :title="'تقرير الطلاب'" :to="{name: 'reports.studentDegrees'}">  تقرير الطلاب</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-12 col-md-12 layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">


                                <div class="row align-items-center">
                                    <div class="col-md-6">
                                        <h4>
                                            <i class="flaticon-computer-4"></i>
                                            تقرير الطلاب
                                        </h4>
                                    </div>
                                    <div class="col-md-6">
                                      <ul class="list-inline top-btns d-flex align-items-center m-0">
                                        <li class="list-inline-item">

                                </li>

                                      </ul>

                                      </div>
                                </div>

                            </div>
                            <div class="widget-content widget-content-area">

                                <form @submit.prevent="getIndexData(1)" v-if="1" style="border: 1px solid #DDD;padding: 20px" class="mb-4">
                                    <div class="form-row">
                                      <div class="col-md-6 mt-2">
                                          <label for=""> التاريخ من <span class="text-danger">*</span></label>
                                          <date-picker v-model="data.searching.date_from" :editable="true" :calendar="'hijri'"></date-picker>
                                        </div>
                                         <div class="col-md-6 mt-2">
                                          <label for="">التاريخ إلى <span class="text-danger">*</span></label>
                                          <date-picker v-model="data.searching.date_to" :editable="true" :calendar="'hijri'"></date-picker>
                                        </div>
                                        <div class="col-md-4">
                                          <label for="">الصف الدراسى</label>
                                          <treeselect :options="groups" v-model="data.searching.group_id" @select="getLessons" :multiple="false" />
                                        </div>
                                        <div class="col-md-4">
                                          <label for="">الحلقة <span class="text-danger">*</span></label>
                                          <treeselect :required="true" :options="lessons" v-model="data.searching.lesson_id" @select="getStudents" :multiple="false" />
                                        </div>
                                        <div class="col-md-4">
                                          <label for="">الطالب </label>
                                          <treeselect :options="students" v-model="data.searching.student_id" :multiple="false"  />
                                        </div>
                                       
                                        
                                        <div class="col-md-4 mt-4">
                                          <button type="submit" name="time" class="search-btn-wg btn-creative btn-3 btn-3e flaticon-search-1"> <span>بحث</span></button>

                                        </div>
                                    </div>
                                </form>
                                <div class="col-md-12">
                                  <button class="btn btn-success" v-if="(data.data && data.data.length > 0) || (multiData && Object.keys(multiData).length > 0) || data.searching.student_id" @click.prevent="print">
                                    <i class="fa fa-print"></i> طباعة
                                  </button>
                                  <button class="btn btn-success ml-2" v-if="(data.data && data.data.length > 0) || (multiData && Object.keys(multiData).length > 0) || data.searching.student_id" @click.prevent="exportStudentExcel">
                                    تصدير Excel
                                  </button>

                                  <div class="col-md-12">

                                  <div class="text-center" v-if="isRequested">
                                    <p>انتظر قليلاً من فضلك نجلب البيانات لك ...</p>
                                  </div>
                                  </div>

                                </div>
                                <div class="table-responsive" id="printMe" v-if="data.searching.student_id">

                                  
                                  <table class="table table-bordered mb-4" v-if="data.data.length">
                                    <tbody>
                                      <tr>
                                        <td>
                                      <img alt="logo" style="width: 58px; height: 58px" :src="data.info.student_image" class="theme-logo">

                                        </td>
                                        <td colspan="2" class="text-center">
                                          <h4>تقرير طالب</h4>
                                          <p> نبعث إليكم هذا التقرير الأسبوعي والذي يوضح مستوى إبنكم في الحفظ والمراجعة للفترة الموضحة ، نأمل منكم الإطلاع على التقرير ، كما ترحب إدارة الحلقات بآرائكم و اقتراحاتكم للرقي بمستوى أبنائنا الطلاب.</p>
                                        </td>
                                        <td>
                                          <img alt="logo" style="width: 58px; height: 58px" :src="settings.image_path" class="theme-logo">
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <span style="width: 50%">الاسم : {{ data.info.student }}</span>
                                          <br>
                                          <span style="width: 50%">الحلقة : {{ data.info.lesson }}</span>
                                        </td>
                                          <td>
                                            <span>عدد ايام الغياب: {{ data.info.abs }}</span>
                                            |
                                            <span>عدد ايام الحضور: {{ data.info.pre }}</span>
                                            |
                                            <span>الاستئذان: {{ data.info.exc }}</span>
                                            |
                                            <span>عدد ايام التأخير: {{ data.info.del }}</span>
                                          </td>
                                        <td>التاريخ من: 
                                          <br>{{ data.searching.date_from }} </td>
                                        <td>التاريخ إلى:
                                          <br>{{ data.searching.date_to }} </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <table class="table table-bordered mb-4" v-if="data.data.length">
                                        <thead>
                                           <tr>
                                            <th></th>
                                            <th colspan="3">الحفظ</th>
                                            <th colspan="3">المراجعة</th>
                                            <th></th>
                                           </tr>
                                            <tr>
                                              <th rowspan="2"> اليوم </th>
                                              <th>من</th>
                                              <th>إلى</th>
                                              <th>الدرجة</th>
                                              <th>من</th>
                                              <th>إلى</th>
                                              <th>الدرجة</th>
                                              <th rowspan="2">التحضير</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                          <tr v-for="(deg, i) in data.data" :key="i">
                                            <td>{{ deg.day }}</td>
                                            <td>{{ deg.save_from }}</td>
                                            <td>{{ deg.save_to }}</td>
                                            <td>{{ deg.save_deg }}</td>
                                            <td>{{ deg.review_from }}</td>
                                            <td>{{ deg.review_to }}</td>
                                            <td>{{ deg.review_deg }}</td>
                                            <td>{{ deg.attend }}</td>
                                          </tr>
                                        </tbody>
                                    </table>
                                    <table class="table table-bordered mb-4" v-if="data.data.length">
                                        <thead>
                                          <tr>
                                            <th>
                                              الدرجة الموزونة
                                            </th>
                                            <th>الحفظ و المراجعة</th>
                                            <th>السلوك</th>
                                            <th>الانضباط</th>
                                            <th>الزى</th>
                                            <th>النشاط</th>
                                            <th>درجة التميز</th>
                                            <th>المجوعة</th>
                                            <th>التقدير العام **</th>
                                          </tr>
                                          <tr>
                                            <th>الدرجة العليا</th>
                                            <th>80</th>
                                            <th>5</th>
                                            <th>5</th>
                                            <th>5</th>
                                            <th>5</th>
                                            <th>-</th>
                                            <th>100%</th>
                                            <th>-</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <th>درجات الطالب</th>
                                            <td>{{ data.total.save_review }}</td>
                                            <td>{{ data.total.behave }}</td>
                                            <td>{{ data.total.attend }}</td>
                                            <td>{{ data.total.dress }}</td>
                                            <td>{{ data.total.active }}</td>
                                            <td>{{ data.total.add }}</td>
                                            <td>{{ data.total.total }}</td>
                                            <td>{{ data.total.gpa }}</td>
                                          </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div class="table-responsive" id="printMe" v-else>
                                  <div v-for="(multi, i) in multiData" :key="i">
                                    <table class="table table-bordered mb-4">
                                    <tbody>
                                      <tr>
                                        <td>
                                      <img alt="logo" style="width: 58px; height: 58px" :src="multi.info.student_image" class="theme-logo">

                                        </td>
                                        <td colspan="2" class="text-center">
                                          <h4>تقرير طالب</h4>
                                          <p>نبعث إليكم هذا التقرير الأسبوعي والذي يوضح مستوى إبنكم في الحفظ والمراجعة للفترة الموضحة ، نأمل منكم الإطلاع على التقرير ، كما ترحب إدارة الحلقات بآرائكم و اقتراحاتكم للرقي بمستوى أبنائنا الطلاب.</p>
                                        </td>
                                        <td>
                                          <img alt="logo" style="width: 58px; height: 58px" :src="settings.image_path" class="theme-logo">
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <span style="width: 50%">الاسم : {{ multi.info.student }}</span>
                                          <br>
                                          <span style="width: 50%">الحلقة : {{ multi.info.lesson }}</span>
                                        </td>
                                          <td>
                                            <span>عدد ايام الغياب: {{ multi.info.abs }}</span>
                                            |
                                            <span>عدد ايام الحضور: {{ multi.info.pre }}</span>
                                            |
                                            <span>الاستئذان: {{ multi.info.exc }}</span>
                                            |
                                            <span>عدد ايام التأخير: {{ multi.info.del }}</span>
                                          </td>
                                        <td>التاريخ من: 
                                          <br>{{ data.searching.date_from }} </td>
                                        <td>التاريخ إلى:
                                          <br>{{ data.searching.date_to }} </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <table class="table table-bordered mb-4">
                                        <thead>
                                           <tr>
                                            <th></th>
                                            <th colspan="3">الحفظ</th>
                                            <th colspan="3">المراجعة</th>
                                            <th></th>
                                           </tr>
                                            <tr>
                                              <th rowspan="2"> اليوم </th>
                                              <th>من</th>
                                              <th>إلى</th>
                                              <th>الدرجة</th>
                                              <th>من</th>
                                              <th>إلى</th>
                                              <th>الدرجة</th>
                                              <th rowspan="2">التحضير</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                          <tr v-for="(deg, i) in multi.degrees" :key="i">
                                            <td>{{ deg.day }}</td>
                                            <td>{{ deg.save_from }}</td>
                                            <td>{{ deg.save_to }}</td>
                                            <td>{{ deg.save_deg }}</td>
                                            <td>{{ deg.review_from }}</td>
                                            <td>{{ deg.review_to }}</td>
                                            <td>{{ deg.review_deg }}</td>
                                            <td>{{ deg.attend }}</td>
                                          </tr>
                                        </tbody>
                                    </table>
                                    <table class="table table-bordered mb-4">
                                        <thead>
                                          <tr>
                                            <th>
                                              الدرجة الموزونة
                                            </th>
                                            <th>الحفظ و المراجعة</th>
                                            <th>السلوك</th>
                                            <th>الانضباط</th>
                                            <th>الزى</th>
                                            <th>النشاط</th>
                                            <th>درجة التميز</th>
                                            <th>المجوعة</th>
                                            <th>التقدير العام **</th>
                                          </tr>
                                          <tr>
                                            <th>الدرجة العليا</th>
                                            <th>80</th>
                                            <th>5</th>
                                            <th>5</th>
                                            <th>5</th>
                                            <th>5</th>
                                            <th>-</th>
                                            <th>100%</th>
                                            <th>-</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <th>درجات الطالب</th>
                                            <td>{{ multi.total.save_review }}</td>
                                            <td>{{ multi.total.behave }}</td>
                                            <td>{{ multi.total.attend }}</td>
                                            <td>{{ multi.total.dress }}</td>
                                            <td>{{ multi.total.active }}</td>
                                            <td>{{ multi.total.add }}</td>
                                            <td>{{ multi.total.total }}</td>
                                            <td>{{ multi.total.gpa }}</td>
                                          </tr>
                                        </tbody>
                                    </table>
                                  </div>
                                 
                                </div>

                            </div>
                        </div>

                    </div>

                </div>


            </div>


</template>
<script>
import 'vue-select/dist/vue-select.css';
import VueDatetimeJs from 'vue-datetime-js'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { mapGetters } from 'vuex'
import * as XLSX from "xlsx";


export default {
  components: {
    datePicker: VueDatetimeJs,
    Treeselect
  },
  data() {
    return {
      isRequested: false,
    multiData: [],
      chartOptions: {
            chart: {
              width: 380,
              type: 'donut',
            },
            plotOptions: {
              pie: {
                startAngle: -90,
                endAngle: 270
              }
            },
            labels: ['اجمالى الحضور', 'اجمالى الغياب', 'اجمالى الاستأذان', 'اجمالى التأخير'],
            dataLabels: {
              enabled: false,
            },
            fill: {
              type: 'gradient',
            },
            legend: {
              formatter: function(val, opts) {
                return val + " - " + opts.w.globals.series + '%'
              }
            },
            title: {
              text: ''
            },
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'bottom'
                }
              }
            }]
          },
      printData: {
      },
      data: {
        data: {},
        info: {},
        total: {},
        searching:{
            group_id: '',
            lesson_id: '',
            student_id: '',
            date_from: '',
            date_to: '',
            perPage: 10,
            sorting: 'desc'
        },
        paginated: {},
        showFilter: false,
      },
       options: [],
       stages: [],
       groups: [],
       lessons: [],
       students: [],
       searchingMode: 0,
       stage: {},
       group: {},
    };
  },
  created(){
      this.search(null, '', this, 'lesson');
      this.search(null, '', this, 'student');
      this.search(null, '', this, 'group');
  },
  methods: {
    exportStudentExcel() {
  const wb = XLSX.utils.book_new();
  const rows = [];
  const self = this;

  // =========================
  // Header (مثل نموذج الإكسل)
  // =========================
  rows.push([
    "الحلقة",
    "الطالب",
    "اليوم",
    "حفظ من",
    "حفظ إلى",
    "درجة الحفظ",
    "مراجعة من",
    "مراجعة إلى",
    "درجة المراجعة",
    "التحضير",
    "عدد أيام الحضور",
    "عدد أيام الغياب",
    "عدد أيام الاستئذان",
    "عدد أيام التأخير",
    "الحفظ والمراجعة",
    "السلوك",
    "الانضباط",
    "الزي",
    "النشاط",
    "درجة التميز",
    "المجموع( الدرجة الموزونة ) المجموعة",
    "التقدير العام",
    "من تاريخ",
    "إلى تاريخ"
  ]);

  // =========================
  // Helper: إضافة بيانات طالب
  // =========================
  function appendStudent(info, degrees, total) {
    if (!Array.isArray(degrees)) return;

    degrees.forEach(function (d) {
      rows.push([
        info.lesson || "",
        info.student || "",
        d.day || "",
        d.save_from || "",
        d.save_to || "",
        d.save_deg || "",
        d.review_from || "",
        d.review_to || "",
        d.review_deg || "",
        d.attend || "",
        info.pre || 0,
        info.abs || 0,
        info.exc || 0,
        info.del || 0,
        total.save_review || 0,
        total.behave || 0,
        total.attend || 0,
        total.dress || 0,
        total.active || 0,
        total.add || 0,
        total.total || 0,
        total.gpa || "",
        self.data.searching.date_from || "",
        self.data.searching.date_to || ""
      ]);
    });
  }

  // =========================
  // حالة: طالب واحد
  // =========================
  if (this.data.searching && this.data.searching.student_id) {
    appendStudent(this.data.info, this.data.data, this.data.total);
  }

  // =========================
  // حالة: عدة طلاب
  // =========================
  else {
    let list = [];

    if (Array.isArray(this.multiData)) {
      list = this.multiData;
    } else if (this.multiData && typeof this.multiData === "object") {
      list = Object.values(this.multiData);
    }

    list.forEach(function (multi) {
      appendStudent(multi.info, multi.degrees, multi.total);
    });
  }

  // =========================
  // إنشاء الشيت
  // =========================
  const ws = XLSX.utils.aoa_to_sheet(rows);

  // دعم RTL (عربي)
  ws["!rtl"] = true;

  // عرض الأعمدة
  ws["!cols"] = [
    { wch: 20 }, // الحلقة
    { wch: 30 }, // الطالب
    { wch: 12 }, // اليوم
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 12 },
    { wch: 15 },
    { wch: 15 },
    { wch: 15 },
    { wch: 15 },
    { wch: 15 },
    { wch: 10 },
    { wch: 10 },
    { wch: 10 },
    { wch: 10 },
    { wch: 12 },
    { wch: 12 },
    { wch: 15 },
    { wch: 15 },
    { wch: 15 }
  ];

  // إضافة الشيت للملف
  XLSX.utils.book_append_sheet(wb, ws, "تقرير الطلاب");

  // حفظ الملف
  XLSX.writeFile(wb, "student-report.xlsx");
},
    resortData(){
        this.data.searching.sorting = this.data.searching.sorting == 'asc' ? 'desc' : 'asc';
        this.getIndexData(1);
    },
    print(){
      setTimeout(() => {
      this.print_element('printMe', 'تقرير الطلاب');

      }, 3000);
    },
    onSearchStage(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this, 'stage');
      }
    },
    onSearchGroup(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this, 'group');
      }
    },
    search(loading, w, vm, type){
      this.$baseApi.get('/reports/absences?pluck=1&search='+w+'&pluckType='+type).then((response)=>{
            if(loading){
            loading(false);
            }
            if(response.data.code == 200){
              if(type == 'stage'){
                this.stages = response.data.data.options;
              }
              if(type == 'group'){
                this.groups = response.data.data.options;
              }
              if(type == 'lesson'){
                this.lessons = response.data.data.options;
              }
              if(type == 'student'){
                this.students = response.data.data.options;
              }
            }else{
                alert(response.data.error.error);
            }
        });
    },

    getGroups(val){
      this.$baseApi.get('/reports/absences?pluck=1&i='+val.id+'&pluckType=group').then((response)=>{
            
            if(response.data.code == 200){
              
              this.groups = response.data.data.options;
              
            }else{
                alert(response.data.error.error);
            }
        });
    },
    
    getLessons(val){
      this.$baseApi.get('/reports/absences?pluck=1&group='+val.id+'&i='+val.id+'&pluckType=lesson').then((response)=>{
            
            if(response.data.code == 200){
              
              this.lessons = response.data.data.options;
              
            }else{
                alert(response.data.error.error);
            }
        });
    },
    getStudents(val){
      this.students = [];
      this.$baseApi.get('/reports/absences?pluck=1&lesson='+val.id+'&i='+val.id+'&pluckType=student').then((response)=>{
            
            if(response.data.code == 200){
              
              this.students = response.data.data.options;
              
            }else{
                alert(response.data.error.error);
            }
        });
    },
      getIndexData(page){
        if(this.data.searching.date_from == '' || this.data.searching.date_to == '' || this.data.searching.lesson_id == ''){
          return;
        }
        this.isRequested = true;
        this.data.data   = {};
        this.data.info   = {};
        this.data.total  = {};
        this.multiData   = [];

        this.$baseApi.get('/reports/student-degree?data=' + 1, {
                    params: this.data.searching
                }).then((response)=>{
            if(response.data.code == 200){
        this.isRequested = false;
            if(this.data.searching.student_id){
                this.data.data = response.data.data.degrees;
                this.data.info = response.data.data.info;
                this.data.total = response.data.data.total;
            }else{
                this.multiData = response.data.data.multi;
            }
           
            }else{
              this.isRequested = false;
                alert(response.data.error.error);
            }
        });
      },
      deleteData(data){
          this.data.data.splice(this.data.data.indexOf(data), 1);
      },
    clearFilter(items) {
      this.data.showFilter = !this.data.showFilter
      if (!this.data.showFilter) {
        for (const itemsKey in items) {
          this.data.searching[itemsKey] = ''
        }
        this.getIndexData(1);
      }
    },
    makePerc(n, t){
      if(n == 0 || t == 0){
        return 0;
      }
      return (n/t) * 100;
    }
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    },
    ...mapGetters({
      settings: 'GET_WEBSITE_SETTING_KEYS'
    })
  },
   watch: {
    // Note: only simple paths. Expressions are not supported.
    stage(newValue) {
      this.data.searching.stage_id = newValue.id;
    },
    group(newValue) {
      this.data.searching.group_id = newValue.id;
    },
  }
};
</script>
<style>
</style>
